import { JsonToMjmlOption } from "@easy-email-pro-core/utils/isProductionMode";
import React, { useContext } from "react";

export const useEmailGlobalContext = () => {
  return useContext(EmailGlobalContext);
};

export const EmailGlobalContextProvider: React.FC<
  {
    context: GlobalEmailContext;
  } & { children: React.ReactNode }
> = (props) => {
  return (
    <EmailGlobalContext.Provider value={{ context: props.context }}>
      {props.children}
    </EmailGlobalContext.Provider>
  );
};

export class GlobalEmailContext {
  mode: JsonToMjmlOption["mode"];
  constructor(options: { mode: JsonToMjmlOption["mode"] }) {
    this.mode = options.mode;
  }

  headItems: Array<{
    content: string;
    id?: string;
    type: "style" | "selector" | "head";
  }> = [];

  getHeadContent() {
    return [...new Set(this.headItems.map((item) => item.content))].join("\n");
  }

  addStyle = (params: { content: string; inline?: "inline"; id?: string }) => {
    this.addHeadItems({
      type: "style",
      id: params.id,
      content: `<mj-style ${
        params.inline && this.mode === "production" ? `inline="inline"` : ""
      }>${params.content}</mj-style>`,
    });
  };
  addAttributeBySelector(params: {
    selector: string;
    attributes: Record<string, string | number>;
  }) {
    this.addHeadItems({
      type: "selector",
      content: `<mj-html--attributes>
      <mj-selector path="${params.selector}">
      ${Object.keys(params.attributes).map(
        (key) =>
          `<mj-html--attribute name="${key}">${params.attributes[key]}</mj-html--attribute>`
      )}
      </mj-selector>
    </mj-html--attributes>`,
    });
  }

  addHeadItems(params: GlobalEmailContext["headItems"][0]) {
    if (!params.id) {
      this.headItems.push({
        id: params.id,
        content: params.content,
        type: params.type,
      });
    } else if (!this.headItems.find((item) => item.id === params.id)) {
      this.headItems.push({
        id: params.id,
        content: params.content,
        type: params.type,
      });
    }
  }
}

const EmailGlobalContext = React.createContext<{ context: GlobalEmailContext }>(
  {} as any
);
